import { useSearchParamActions } from "./useSearchParamActions";

export function useSetMultipleParams() {
  const { updateSearchParams } = useSearchParamActions();

  return [updateSearchParams];
}
